import React from 'react';
import { ResponsiveContainer, LineChart as ReLineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';
import { lineChartData, lineCustomSeries } from './data';
import { useStateContext } from '../../contexts/ContextProvider';

const LineChart = ({ height = 420 }: any) => {
  const { currentMode } = useStateContext();

  // Merge multiple series data into a single array keyed by date string
  const merged: any[] = [];
  if (lineChartData && lineChartData.length > 0) {
    const len = lineChartData[0].length;
    for (let i = 0; i < len; i++) {
      const row: any = { date: lineChartData[0][i].x };
      lineChartData.forEach((seriesArr: any[], si: number) => {
        row[`series${si}`] = seriesArr[i] ? seriesArr[i].y : null;
      });
      merged.push(row);
    }
  }

  const colors = ['#8884d8', '#82ca9d', '#ff7300', '#ff8042'];

  return (
    <div style={{ width: '100%', height, background: currentMode === 'Dark' ? '#33373E' : '#fff', padding: 8, borderRadius: 6 }}>
      <ResponsiveContainer width="100%" height="100%">
        <ReLineChart data={merged}>
          <CartesianGrid strokeDasharray="3 3" stroke={currentMode === 'Dark' ? '#444' : '#e6e6e6'} />
          <XAxis dataKey="date" tickFormatter={(d: any) => {
            try { const dt = new Date(d); return dt.getFullYear(); } catch { return d; }
          }} tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
          <YAxis tick={{ fill: currentMode === 'Dark' ? '#d1d5db' : '#374151' }} />
          <Tooltip labelFormatter={(label) => {
            try { const dt = new Date(label); return dt.toDateString(); } catch { return label; }
          }} contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
          <Legend wrapperStyle={{ color: currentMode === 'Dark' ? '#eee' : '#333' }} />
          {lineChartData.map((series: any, idx: number) => (
            <Line key={idx} type="monotone" dataKey={`series${idx}`} stroke={colors[idx % colors.length]} dot={{ r: 3 }} />
          ))}
        </ReLineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChart;
